import React from "react";

function Footer() {
    return (
        <footer>(c) 2020 by shopigent.com</footer>
    )
}

export default Footer